export const lvbetcomLanguageSwitcherFlagMap: Record<string, string> = {
  en: 'gb',
  es: 'cl'
};
